module.exports = __webpack_public_path__ + "img/product_stat2.8a4fba30.png";